(function() {
  document.addEventListener('DOMContentLoaded', function() {

    /* ── Discount toggle ── */
    var toggleBtn  = document.getElementById('cart-discount-toggle');
    var body       = document.getElementById('cart-discount-body');
    var chevron    = toggleBtn && toggleBtn.querySelector('.cart-discount__chevron');

    if (toggleBtn && body) {
      toggleBtn.addEventListener('click', function() {
        var open = body.style.display !== 'none';
        body.style.display = open ? 'none' : 'block';
        toggleBtn.setAttribute('aria-expanded', !open);
        if (chevron) chevron.style.transform = open ? '' : 'rotate(180deg)';
      });
    }

    /* ── Smart pre-fill: check for pending reward from review submission ── */
    var input        = document.getElementById('cart-discount-input');
    var rewardNotice = document.getElementById('cart-reward-notice');
    var rewardMsg    = document.getElementById('cart-reward-msg');

    try {
      var pending = JSON.parse(localStorage.getItem('gg_pending_reward') || 'null');
      var TWO_WEEKS = 14 * 24 * 60 * 60 * 1000;
      if (pending && pending.code && (Date.now() - pending.ts) < TWO_WEEKS) {
        /* Pre-fill the input and open the section */
        if (input) input.value = pending.code;
        if (body)  body.style.display = 'block';
        if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'true');
        if (chevron) chevron.style.transform = 'rotate(180deg)';
        if (rewardNotice) rewardNotice.style.display = 'flex';
        if (rewardMsg) rewardMsg.textContent = 'Your review reward (' + pending.code + ') is ready!';
      }
    } catch(e) {}

    /* ── Apply button → redirect to checkout with discount ── */
    var applyBtn     = document.getElementById('cart-discount-apply');
    var checkoutBtn  = document.getElementById('cart-checkout-btn');

    function goToCheckout() {
      var code = input ? input.value.trim() : '';
      /* Clear the pending reward once used */
      if (code) {
        try { localStorage.removeItem('gg_pending_reward'); } catch(e) {}
        window.location.href = '/checkout?discount=' + encodeURIComponent(code);
      } else {
        window.location.href = '/checkout';
      }
    }

    if (applyBtn) applyBtn.addEventListener('click', goToCheckout);
    if (checkoutBtn) checkoutBtn.addEventListener('click', goToCheckout);

    /* Allow Enter key in the input */
    if (input) {
      input.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') { e.preventDefault(); goToCheckout(); }
      });
    }
  });
})();